import { render } from "./App.vue?vue&type=template&id=1c0d33c8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1c0d33c8&lang=css"

import exportComponent from "/opt/stagecoach/apps/pa-wildflower-selector/deployments/2022-05-18-09-54-08/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__